import React from 'react'
import SearchPageRelatedPost from './searchPageRelatedPost'

const SearchPageRelatedPosts = ({posts}) => {
  const generateUID = () => {
    return Math.random().toString(32).substring(2)
  }

  return (
    <section className='page-section'>
      <div className='grid-container'>
        <div className='search-related-posts__posts-section'>
          <div className='sidebar-s -size-fixed-tablet is-hidden-phone'>
            <div className='search-page-content__sidebar-spacer' />
          </div>
          <div className='content-l -size-scale-tablet content-right'>
            <ol className='search-related-posts__post_list'>
              {posts.map((post) =>
                <SearchPageRelatedPost
                  key={generateUID()}
                  post={post}
                />
              )}
            </ol>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SearchPageRelatedPosts



// WEBPACK FOOTER //
// ./client/pages/search/content/searchPageRelatedPosts.js